<template>
  <router-view />
</template>

<script>
export default {
  name: "app-frame"
};
</script>

<style lang="scss" scoped></style>
